import React, { createContext, useContext, useMemo } from "react";
import { FormProvider } from "react-hook-form";
import { useCategoryFormLogic } from "../hooks/useCategoryFormLogic";

type CategoryFormContextType = {
  category?: any;
  categories: any[];
  selectedCategory: string;
  setSelectedCategory: (value: string) => void;
  parentSelectedCategory: string;
  setParentSelectedCategory: (value: string) => void;
  toggleOpenPopin: (value: boolean) => void;
  setActiveCategory?: (category: any) => void;
};

export const CategoryFormContext = createContext<
  CategoryFormContextType | undefined
>(undefined);

export const useCategoryForm = () => {
  const context = useContext(CategoryFormContext);
  if (context === undefined) {
    throw new Error("useCategoryForm must be used within CategoryFormProvider");
  }
  return context;
};

type CategoryFormProviderProps = {
  children: React.ReactNode;
  category?: any;
  categories: any[];
  toggleOpenPopin: (value: boolean) => void;
  setActiveCategory?: (category: any) => void;
};

export const CategoryFormProvider: React.FC<CategoryFormProviderProps> = ({
  children,
  category,
  categories,
  toggleOpenPopin,
  setActiveCategory,
}) => {
  const {
    form,
    selectedCategory,
    setSelectedCategory,
    parentSelectedCategory,
    setParentSelectedCategory,
  } = useCategoryFormLogic(category);

  const value = useMemo(
    () => ({
      category,
      categories,
      selectedCategory,
      setSelectedCategory,
      parentSelectedCategory,
      setParentSelectedCategory,
      toggleOpenPopin,
      setActiveCategory,
    }),
    [
      category,
      categories,
      selectedCategory,
      setSelectedCategory,
      parentSelectedCategory,
      setParentSelectedCategory,
      toggleOpenPopin,
      setActiveCategory,
    ]
  );

  return (
    <CategoryFormContext.Provider value={value}>
      <FormProvider {...form}>{children}</FormProvider>
    </CategoryFormContext.Provider>
  );
};
